<template lang="pug">
  v-dialog(v-model='dialogImportacionP2' scrollable persistent :max-width='tamanno')
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        span.headline Información de Gastos
      v-card-text
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-text
                v-row(dense class='d-flex justify-center')
                  v-btn.espacio1(color='success' @click='gastoOrigenDestino()') Gastos Origen-Destino
                  v-btn.espacio2(color='success' @click='soporteGasto()') Soporte de Gastos
                  v-btn.espacio3(color='success' @click='gastoOperativo()') Gastos Operativos
              v-card-text(v-if='origenDestino')
                v-row(dense class='d-flex justify-center')
                  v-card-subtitle.title(style='color: black') Gastos Locales Origen
                    v-btn.mx-2(v-if="read === false" fab width='8%' height= '70%' dark small color='success' @click='enterGastoLocal()')
                      v-icon(dark='') mdi-plus
                  table(border='0' width='100%' align='center')
                    tr(style="border: 1px solid grey;")
                      td(align="center")
                        div
                          span.bold(style='color: black') Descripción
                      td(align="center")
                        div
                          span.bold(style='color: black') Cotización
                      td(align="center")
                        div
                          span.bold(style='color: black') Empresa
                      td(align="center")
                        div
                          span.bold(style='color: black') Documento
                      td(align="center")
                        div
                          span.bold(style='color: black') Monto($)
                      td(align="center")
                        div
                          span.bold(style='color: black') Estatus de Pago
                      td(align="center")
                    tr(v-for="(gastoL, k) in gastosLocales" :key="k" align='center')
                      td.inputGastos
                        v-text-field(style='font-size: 13px; margin-bottom: -13px;' :readonly='read' dense outlined v-model='gastoL.descripcion')
                      td.inputCotiMont
                        v-text-field(style='font-size: 13px; margin-bottom: -13px;' :readonly='read' dense outlined v-model='gastoL.cotizacion' type='number' min="0" prefix="$" @change="changeCotizacion")
                      td.inputGastos
                        v-text-field(style='font-size: 13px; margin-bottom: -13px;' :readonly='read' dense outlined v-model='gastoL.nombreEmpresa')
                      td.inputDocumento
                        v-text-field(style='font-size: 13px; margin-bottom: -13px;' :readonly='read' dense outlined v-model='gastoL.nroDocumento')
                      td.inputCotiMont
                        v-text-field(style='font-size: 13px; margin-bottom: -13px;' :readonly='read' dense outlined v-model='gastoL.monto' type='number' min="0" prefix="$" @change="changeMonto")
                      td.inputEstatus
                        v-select(style='font-size: 13px; margin-bottom: -13px;' :readonly='read' dense outlined v-model='gastoL.estatus' :items='statusPago')
                      td.inputGastos2(v-if="read === false")
                        v-icon(color='error' @click="deleteRowLocal(k, gastoL)") mdi-delete
                p.top-black
                v-row(dense class='d-flex justify-center')
                  v-card-subtitle.title(style='color: black') Gastos Locales Destino
                    v-btn.mx-2(v-if="read === false" fab width='8%' height= '70%' dark small color='success' @click='enterGastoDestino()')
                      v-icon(dark='') mdi-plus
                  table(border='0' width='100%' align='center')
                    tr(style="border: 1px solid grey;")
                      td(align="center")
                        div
                          span.bold(style='color: black') Descripción
                      td(align="center")
                        div
                          span.bold(style='color: black') Cotización
                      td(align="center")
                        div
                          span.bold(style='color: black') Empresa
                      td(align="center")
                        div
                          span.bold(style='color: black') Documento
                      td(align="center")
                        div
                          span.bold(style='color: black') Monto($)
                      td(align="center")
                        div
                          span.bold(style='color: black') Estatus de Pago
                      td(align="center")
                    tr(v-for="(gastoD, k) in gastosDestino" :key="k" align='center')
                      td.inputGastos
                        v-text-field(style='font-size: 13px; margin-bottom: -13px;' :readonly='read' dense outlined v-model='gastoD.descripcion')
                      td.inputCotiMont
                        v-text-field(style='font-size: 13px; margin-bottom: -13px;' :readonly='read' dense outlined v-model='gastoD.cotizacion' type='number' min="0" prefix="$" @change="changeCotizacion")
                      td.inputGastos
                        v-text-field(style='font-size: 13px; margin-bottom: -13px;' :readonly='read' dense outlined v-model='gastoD.nombreEmpresa')
                      td.inputDocumento
                        v-text-field(style='font-size: 13px; margin-bottom: -13px;' :readonly='read' dense outlined v-model='gastoD.nroDocumento')
                      td.inputCotiMont
                        v-text-field(style='font-size: 13px; margin-bottom: -13px;' :readonly='read' dense outlined v-model='gastoD.monto' type='number' min="0" prefix="$" @change="changeMonto")
                      td.inputEstatus
                        v-select(style='font-size: 13px; margin-bottom: -13px;' :readonly='read' dense outlined v-model='gastoD.estatus' :items='statusPago')
                      td.inputGastos2(v-if="read === false")
                        v-icon(color='error' @click="deleteRowDestino(k, gastoD)") mdi-delete
                p.top-black
                p
                v-row(dense class='d-flex justify-end')
                  v-col(cols='12' sm='12' md='3')
                    div(align="center")
                      span.bold(style='color: black;') Total Cotización
                      v-text-field.size(dense outlined readonly v-model='gastoCotizacionTotal' prefix="$")
                  v-col(cols='12' sm='12' md='3')
                    div(align="center")
                      span.bold(style='color: black;') Total Monto
                      v-text-field.size(dense outlined readonly v-model='gastoMontoTotal' prefix="$")
              v-card-text(v-if='soporte')
                v-row(dense)
                  v-col(cols='12' sm='12' md='12' v-if='extension === "pdf"')
                    v-flex.img-pro(xs12 sm12 md12)
                      v-btn.mx-2(fab dark x-large color='success' style='border-radius: 10%;')
                        v-icon(large) mdi-text-box-check
                  v-col(cols='12' sm='12' md='12' v-else)
                    v-flex.img-pro(xs12 sm12 md12)
                      img(:src='ruta + img' v-if='img && !formP2.archivo.imageUrl' style='width:310px;height:auto')
                      img(:src='formP2.archivo.imageUrl' v-if='formP2.archivo.imageUrl' style='width:310px;height:auto')
                  p
                  v-col(cols='12' sm='12' md='12')
                    v-text-field(rounded outlined style='height: 56px;margin: 0px 0px 10px;' v-if="!read" label='Seleccione la Imagen o Archivo' @click='pickFile' v-model='formP2.archivo.imageName' prepend-inner-icon='mdi-paperclip')
                    input(type='file' style='display: none' ref='image' accept='image/*, application/pdf' @change="onFilePicked($event)")
              v-card-text(v-if='operativo')
                v-row(dense class='d-flex justify-center')
                  v-card-subtitle.title(style='color: black') Gastos de Nacionalización
                  table(border='0' width='100%' align='center')
                    tr(style="border: 1px solid grey;")
                      td(align="center")
                        div
                          span.bold(style='color: black') # Preliquidación
                      td(align="center")
                        div
                          span.bold(style='color: black') Manejo de Carga
                      td(align="center")
                        div
                          span.bold(style='color: black') Seguridad y Vigilacia
                      td(align="center")
                        div
                          span.bold(style='color: black') Despacho de Carga de Contenedores
                      td(align="center")
                        div
                          span.bold(style='color: black') Posicionamiento
                    tr(align='center')
                      td.inputOperativo
                        v-text-field(style='font-size: 13px; margin-bottom: -13px;' dense outlined :readonly='read' v-model='preliquidacion' type='number' min="0")
                      td.inputOperativo
                        v-text-field(style='font-size: 13px; margin-bottom: -13px;' dense outlined :readonly='read' v-model='manejoCarga' type='number' min="0" prefix="$")
                      td.inputOperativo
                        v-text-field(style='font-size: 13px; margin-bottom: -13px;' dense outlined :readonly='read' v-model='seguridadVigilancia' type='number' min="0" prefix="$")
                      td.inputOperativo2
                        v-text-field(style='font-size: 13px; margin-bottom: -13px;' dense outlined :readonly='read' v-model='despachoCargaContenedor' type='number' min="0" prefix="$")
                      td.inputOperativo
                        v-text-field(style='font-size: 13px; margin-bottom: -13px;' dense outlined :readonly='read' v-model='posicionamiento' type='number' min="0" prefix="$")
                v-row(dense class='d-flex justify-end')
                  v-col(cols='12' sm='12' md='4')
                    div(align="center")
                      span.bold(style='color: black;') Total Preliquidación
                      v-text-field(dense outlined :readonly='read' v-model='totalPreliquidacion' prefix="$")
                p.top-black
                v-flex(xs12 style='margin-top:5px;padding-left:20px;margin-bottom:5px')
                  v-layout(wrap='')
                    v-flex(xs12 sm12 md6)
                      v-row(dense class='d-flex justify-center')
                        v-card-subtitle.title(style='color: black') Alcances
                          v-btn.mx-2(v-if="read === false" fab width='16%' height= '62%' dark small color='success' @click='enterAlcance()')
                            v-icon(dark='') mdi-plus
                      v-row(dense class='d-flex justify-center')
                        table(border='0' width='60%' align='center')
                          tr(style="border: 1px solid grey;")
                            td(align="center")
                              div
                                span.bold(style='color: black') Fecha
                            td(align="center")
                              div
                                span.bold(style='color: black') Monto
                            td(align="center")
                          tr(v-for="(alca, k) in alcances" :key="k" align='center')
                            td.inputTasa
                              v-text-field(style='font-size: 13px; margin-bottom: -13px;' :readonly='read' dense outlined v-model='alca.fecha' v-mask="'####-##-##'")
                            td.inputTasa2
                              v-text-field(style='font-size: 13px; margin-bottom: -13px;' :readonly='read' dense outlined v-model='alca.monto' type='number' min="0" prefix="$" @change="changeMontoAlcance")
                            td.inputGastos2(v-if="read === false")
                              v-icon(color='error' @click="deleteRowAlcance(k, alca)") mdi-delete
                      v-row(dense class='d-flex justify-start')
                        v-col(cols='12' sm='12' md='4')
                          div(align="center")
                            span.bold(style='color: black;') Total Alcances
                            v-text-field(dense outlined :readonly='read' v-model='totalAlcance' prefix="$")  
                    v-flex(xs12 sm12 md6)
                      v-row(dense class='d-flex justify-center' style='margin-right:15px')
                        v-card-subtitle.title(style='color: black') Tasas e Impuestos
                      v-row(dense style='margin-right:15px')
                        v-col(cols='12' sm='12' md='6')
                          div(align="center")
                            span.bold(style='color: black;') Tasa Servicio Aduana (SENIAT)
                            v-text-field(dense outlined :readonly='read' v-model='tasaServicio' type='number' min="0" prefix="$")
                        v-col(cols='12' sm='12' md='6')
                          div(align="center")
                            span.bold(style='color: black;') Impuestos de Importación
                            v-text-field(dense outlined :readonly='read' v-model='impuestoImportacion' type='number' min="0" prefix="$")
                        v-col(cols='12' sm='12' md='6')
                          div(align="center")
                            span.bold(style='color: black;') Impuesto a las imp. Ordinarias
                            v-text-field(dense outlined :readonly='read' v-model='importacionOrdinaria' type='number' min="0" prefix="$")
                        v-col(cols='12' sm='12' md='6')
                          div(align="center")
                            span.bold(style='color: black;') Impuestos al Valor Agregado
                            v-text-field(dense outlined :readonly='read' v-model='valorAgregadoImportacion' type='number' min="0" prefix="$")
                        v-col(cols='12' sm='12' md='6')
                          div(align="center")
                            span.bold(style='color: black;') Servicio de Aduana
                            v-text-field(dense outlined :readonly='read' v-model='servicioAduana' type='number' min="0" prefix="$")
                        v-col(cols='12' sm='12' md='6')
                          div(align="center")
                            span.bold(style='color: black;') Estampillas
                            v-text-field(dense outlined :readonly='read' v-model='estampillas' type='number' min="0" prefix="$")
                      v-row(dense class='d-flex justify-end' style='margin-right:15px')
                        v-col(cols='12' sm='12' md='4')
                          div(align="center")
                            span.bold(style='color: black;') Total Impuestos
                            v-text-field(dense outlined readonly v-model='totalTasaImpuesto' prefix="$")  
      v-card-actions
        v-btn(color='error' style='width: 10%' small dark @click='closePaso2' v-if='tamanno === "90%" || tamanno === "80%"')
          v-icon mdi-arrow-left-thick
          | Atras
        v-btn(color='error' style='width: 13%' small dark @click='closePaso2' v-if='tamanno === "60%"')
          v-icon mdi-arrow-left-thick
          | Atras
        v-spacer
        v-btn(v-if="read === false" color='success' small dark @click='terminarGuardar()')
          v-icon mdi-content-save
          | Terminar y Guardar
        v-btn(color='blue', small dark @click='paso3')
          | Continuar
          v-icon mdi-arrow-right-thick
    ImportacionP3(:dialogImportacionP3='dialogImportacionP3' @close='closePaso3' @closeTodoP3='closeTodoP3' @closeSave3='closeSave3')
</template>

<script>
import { EventBus } from '../Events'
import ImportacionP3 from '../components/ImportacionP3'
import { server, port } from '../services/environment';
export default {
  props: ['dialogImportacionP2'],
  data: () => ({
    tamanno: '90%',
    dialogImportacionP3: false,
    origenDestino: false,
    soporte: false,
    operativo: false,
    img: '',
    extension: '',
    ruta: server + ":" + port,
    statusPago: [
      'Pagado',
      'Por Pagar'
    ],
    gastosLocales: [                       // Local-Destino
      {
        descripcion: 'FLETE INTERNACIONAL',
        cotizacion: 0,
        nombreEmpresa: '',
        nroDocumento: '',
        monto: 0,
        estatus: ''
      },
      {
        descripcion: 'GASTOS ADMINISTRATIVOS ORIGEN',
        cotizacion: 0,
        nombreEmpresa: '',
        nroDocumento: '',
        monto: 0,
        estatus: ''
      }
    ],
    gastosDestino: [
      {
        descripcion: 'BOLIPUERTOS (ACCESOS)',
        cotizacion: 0,
        nombreEmpresa: '',
        nroDocumento: '',
        monto: 0,
        estatus: ''
      },
      {
        descripcion: 'DEMORA (DÍAS)',
        cotizacion: 0,
        nombreEmpresa: '',
        nroDocumento: '',
        monto: 0,
        estatus: ''
      },
      {
        descripcion: 'EMISIÓN DEL BL',
        cotizacion: 0,
        nombreEmpresa: '',
        nroDocumento: '',
        monto: 0,
        estatus: ''
      },
      {
        descripcion: 'ELEVADORA DE VACÍO-DEVOLUCIÓN DE EQUIPO',
        cotizacion: 0,
        nombreEmpresa: '',
        nroDocumento: '',
        monto: 0,
        estatus: ''
      },
      {
        descripcion: 'DEPOSITO DE GARANTÍA',
        cotizacion: 0,
        nombreEmpresa: '',
        nroDocumento: '',
        monto: 0,
        estatus: ''
      },
      {
        descripcion: 'IMPUESTO DE IMPORTACIÓN',
        cotizacion: 0,
        nombreEmpresa: '',
        nroDocumento: '',
        monto: 0,
        estatus: ''
      },
      {
        descripcion: 'PAGOS PLANILLLAS SENIAT',
        cotizacion: 0,
        nombreEmpresa: '',
        nroDocumento: '',
        monto: 0,
        estatus: ''
      },
      {
        descripcion: 'PRELIQUIDACIÓN-DESPACHO',
        cotizacion: 0,
        nombreEmpresa: '',
        nroDocumento: '',
        monto: 0,
        estatus: ''
      },
      {
        descripcion: 'INSPECCIÓN',
        cotizacion: 0,
        nombreEmpresa: '',
        nroDocumento: '',
        monto: 0,
        estatus: ''
      },
      {
        descripcion: 'SEGURO',
        cotizacion: 0,
        nombreEmpresa: '',
        nroDocumento: '',
        monto: 0,
        estatus: ''
      },
      {
        descripcion: 'ALMACENADORA',
        cotizacion: 0,
        nombreEmpresa: '',
        nroDocumento: '',
        monto: 0,
        estatus: ''
      },
    ],
    gastoCotizacionTotal: 0,
    gastoMontoTotal: 0,
    preliquidacion: 0,                     // Gasto Nacionalizacion
    manejoCarga: 0,
    seguridadVigilancia: 0,
    despachoCargaContenedor: 0,
    posicionamiento: 0,
    totalPreliquidacion: 0,
    alcances: [ { fecha: '', monto: 0 } ], // Gasto Alcances
    totalAlcance: 0,
    tasaServicio: 0,                       // Tasa e Impuestos
    impuestoImportacion: 0,
    importacionOrdinaria: 0,
    valorAgregadoImportacion: 0,
    servicioAduana: 0,
    estampillas: 0,
    totalTasaImpuesto: 0,
    formP2: {},
    defaultFormP2: {},
    editedIndex: 0,
    read: false
  }),

  components: {
    ImportacionP3
  },

  watch: {
    'manejoCarga': function (val) {
      if (val && val !== '') {
        val = parseFloat(val);
        this.seguridadVigilancia !== '' ? this.seguridadVigilancia = parseFloat(this.seguridadVigilancia) : this.seguridadVigilancia = 0
        this.despachoCargaContenedor !== '' ? this.despachoCargaContenedor = parseFloat(this.despachoCargaContenedor) : this.despachoCargaContenedor = 0
        this.posicionamiento !== '' ? this.posicionamiento = parseFloat(this.posicionamiento) : this.posicionamiento = 0
        let to = val + this.seguridadVigilancia + this.despachoCargaContenedor + this.posicionamiento
        this.totalPreliquidacion = to.toFixed(2)
      } else {
        this.seguridadVigilancia !== '' ? this.seguridadVigilancia = parseFloat(this.seguridadVigilancia) : this.seguridadVigilancia = 0
        this.despachoCargaContenedor !== '' ? this.despachoCargaContenedor = parseFloat(this.despachoCargaContenedor) : this.despachoCargaContenedor = 0
        this.posicionamiento !== '' ? this.posicionamiento = parseFloat(this.posicionamiento) : this.posicionamiento = 0
        this.totalPreliquidacion = this.seguridadVigilancia + this.despachoCargaContenedor + this.posicionamiento
        this.totalPreliquidacion = (this.totalPreliquidacion).toFixed(2)
      }
    },
    'seguridadVigilancia': function (val) {
      if (val && val !== '') {
        val = parseFloat(val);
        this.manejoCarga !== '' ? this.manejoCarga = parseFloat(this.manejoCarga) : this.manejoCarga = 0
        this.despachoCargaContenedor !== '' ? this.despachoCargaContenedor = parseFloat(this.despachoCargaContenedor) : this.despachoCargaContenedor = 0
        this.posicionamiento !== '' ? this.posicionamiento = parseFloat(this.posicionamiento) : this.posicionamiento = 0
        let to = val + this.manejoCarga + this.despachoCargaContenedor + this.posicionamiento
        this.totalPreliquidacion = to.toFixed(2)
      } else {
        this.manejoCarga !== '' ? this.manejoCarga = parseFloat(this.manejoCarga) : this.manejoCarga = 0
        this.despachoCargaContenedor !== '' ? this.despachoCargaContenedor = parseFloat(this.despachoCargaContenedor) : this.despachoCargaContenedor = 0
        this.posicionamiento !== '' ? this.posicionamiento = parseFloat(this.posicionamiento) : this.posicionamiento = 0
        this.totalPreliquidacion = this.manejoCarga + this.despachoCargaContenedor + this.posicionamiento
        this.totalPreliquidacion = (this.totalPreliquidacion).toFixed(2)
      }
    },
    'despachoCargaContenedor': function (val) {
      if (val && val !== '') {
        val = parseFloat(val);
        this.manejoCarga !== '' ? this.manejoCarga = parseFloat(this.manejoCarga) : this.manejoCarga = 0
        this.seguridadVigilancia !== '' ? this.seguridadVigilancia = parseFloat(this.seguridadVigilancia) : this.seguridadVigilancia = 0
        this.posicionamiento !== '' ? this.posicionamiento = parseFloat(this.posicionamiento) : this.posicionamiento = 0
        let to = val + this.manejoCarga + this.seguridadVigilancia + this.posicionamiento
        this.totalPreliquidacion = to.toFixed(2)
      } else {
        this.manejoCarga !== '' ? this.manejoCarga = parseFloat(this.manejoCarga) : this.manejoCarga = 0
        this.seguridadVigilancia !== '' ? this.seguridadVigilancia = parseFloat(this.seguridadVigilancia) : this.seguridadVigilancia = 0
        this.posicionamiento !== '' ? this.posicionamiento = parseFloat(this.posicionamiento) : this.posicionamiento = 0
        this.totalPreliquidacion = this.manejoCarga + this.seguridadVigilancia + this.posicionamiento
        this.totalPreliquidacion = (this.totalPreliquidacion).toFixed(2)
      }
    },
    'posicionamiento': function (val) {
      if (val && val !== '') {
        val = parseFloat(val);
        this.manejoCarga !== '' ? this.manejoCarga = parseFloat(this.manejoCarga) : this.manejoCarga = 0
        this.seguridadVigilancia !== '' ? this.seguridadVigilancia = parseFloat(this.seguridadVigilancia) : this.seguridadVigilancia = 0
        this.despachoCargaContenedor !== '' ? this.despachoCargaContenedor = parseFloat(this.despachoCargaContenedor) : this.despachoCargaContenedor = 0
        let to = val + this.manejoCarga + this.seguridadVigilancia + this.despachoCargaContenedor
        this.totalPreliquidacion = to.toFixed(2)
      } else {
        this.manejoCarga !== '' ? this.manejoCarga = parseFloat(this.manejoCarga) : this.manejoCarga = 0
        this.seguridadVigilancia !== '' ? this.seguridadVigilancia = parseFloat(this.seguridadVigilancia) : this.seguridadVigilancia = 0
        this.despachoCargaContenedor !== '' ? this.despachoCargaContenedor = parseFloat(this.despachoCargaContenedor) : this.despachoCargaContenedor = 0
        this.totalPreliquidacion = this.manejoCarga + this.seguridadVigilancia + this.despachoCargaContenedor
        this.totalPreliquidacion = (this.totalPreliquidacion).toFixed(2)
      }
    },
    'tasaServicio': function (val) {
      if (val && val !== '') {
        val = parseFloat(val);
        this.impuestoImportacion !== '' ? this.impuestoImportacion = parseFloat(this.impuestoImportacion) : this.impuestoImportacion = 0
        this.importacionOrdinaria !== '' ? this.importacionOrdinaria = parseFloat(this.importacionOrdinaria) : this.importacionOrdinaria = 0
        this.valorAgregadoImportacion !== '' ? this.valorAgregadoImportacion = parseFloat(this.valorAgregadoImportacion) : this.valorAgregadoImportacion = 0
        this.servicioAduana !== '' ? this.servicioAduana = parseFloat(this.servicioAduana) : this.servicioAduana = 0
        this.estampillas !== '' ? this.estampillas = parseFloat(this.estampillas) : this.estampillas = 0
        let to = val + this.impuestoImportacion + this.importacionOrdinaria + this.valorAgregadoImportacion + this.servicioAduana + this.estampillas
        this.totalTasaImpuesto = to.toFixed(2)
      } else {
        this.impuestoImportacion !== '' ? this.impuestoImportacion = parseFloat(this.impuestoImportacion) : this.impuestoImportacion = 0
        this.importacionOrdinaria !== '' ? this.importacionOrdinaria = parseFloat(this.importacionOrdinaria) : this.importacionOrdinaria = 0
        this.valorAgregadoImportacion !== '' ? this.valorAgregadoImportacion = parseFloat(this.valorAgregadoImportacion) : this.valorAgregadoImportacion = 0
        this.servicioAduana !== '' ? this.servicioAduana = parseFloat(this.servicioAduana) : this.servicioAduana = 0
        this.estampillas !== '' ? this.estampillas = parseFloat(this.estampillas) : this.estampillas = 0
        let to = this.impuestoImportacion + this.importacionOrdinaria + this.valorAgregadoImportacion + this.servicioAduana + this.estampillas
        this.totalTasaImpuesto = to.toFixed(2)
      }
    },
    'impuestoImportacion': function (val) {
      if (val && val !== '') {
        val = parseFloat(val);
        this.tasaServicio !== '' ? this.tasaServicio = parseFloat(this.tasaServicio) : this.tasaServicio = 0
        this.importacionOrdinaria !== '' ? this.importacionOrdinaria = parseFloat(this.importacionOrdinaria) : this.importacionOrdinaria = 0
        this.valorAgregadoImportacion !== '' ? this.valorAgregadoImportacion = parseFloat(this.valorAgregadoImportacion) : this.valorAgregadoImportacion = 0
        this.servicioAduana !== '' ? this.servicioAduana = parseFloat(this.servicioAduana) : this.servicioAduana = 0
        this.estampillas !== '' ? this.estampillas = parseFloat(this.estampillas) : this.estampillas = 0
        let to = val + this.tasaServicio + this.importacionOrdinaria + this.valorAgregadoImportacion + this.servicioAduana + this.estampillas
        this.totalTasaImpuesto = to.toFixed(2)
      } else {
        this.tasaServicio !== '' ? this.tasaServicio = parseFloat(this.tasaServicio) : this.tasaServicio = 0
        this.importacionOrdinaria !== '' ? this.importacionOrdinaria = parseFloat(this.importacionOrdinaria) : this.importacionOrdinaria = 0
        this.valorAgregadoImportacion !== '' ? this.valorAgregadoImportacion = parseFloat(this.valorAgregadoImportacion) : this.valorAgregadoImportacion = 0
        this.servicioAduana !== '' ? this.servicioAduana = parseFloat(this.servicioAduana) : this.servicioAduana = 0
        this.estampillas !== '' ? this.estampillas = parseFloat(this.estampillas) : this.estampillas = 0
        let to = this.tasaServicio + this.importacionOrdinaria + this.valorAgregadoImportacion + this.servicioAduana + this.estampillas
        this.totalTasaImpuesto = to.toFixed(2)
      }
    },
    'importacionOrdinaria': function (val) {
      if (val && val !== '') {
        val = parseFloat(val);
        this.tasaServicio !== '' ? this.tasaServicio = parseFloat(this.tasaServicio) : this.tasaServicio = 0
        this.impuestoImportacion !== '' ? this.impuestoImportacion = parseFloat(this.impuestoImportacion) : this.impuestoImportacion = 0
        this.valorAgregadoImportacion !== '' ? this.valorAgregadoImportacion = parseFloat(this.valorAgregadoImportacion) : this.valorAgregadoImportacion = 0
        this.servicioAduana !== '' ? this.servicioAduana = parseFloat(this.servicioAduana) : this.servicioAduana = 0
        this.estampillas !== '' ? this.estampillas = parseFloat(this.estampillas) : this.estampillas = 0
        let to = val + this.tasaServicio + this.impuestoImportacion + this.valorAgregadoImportacion + this.servicioAduana + this.estampillas
        this.totalTasaImpuesto = to.toFixed(2)
      } else {
        this.tasaServicio !== '' ? this.tasaServicio = parseFloat(this.tasaServicio) : this.tasaServicio = 0
        this.impuestoImportacion !== '' ? this.impuestoImportacion = parseFloat(this.impuestoImportacion) : this.impuestoImportacion = 0
        this.valorAgregadoImportacion !== '' ? this.valorAgregadoImportacion = parseFloat(this.valorAgregadoImportacion) : this.valorAgregadoImportacion = 0
        this.servicioAduana !== '' ? this.servicioAduana = parseFloat(this.servicioAduana) : this.servicioAduana = 0
        this.estampillas !== '' ? this.estampillas = parseFloat(this.estampillas) : this.estampillas = 0
        let to = this.tasaServicio + this.impuestoImportacion + this.valorAgregadoImportacion + this.servicioAduana + this.estampillas
        this.totalTasaImpuesto = to.toFixed(2)
      }
    },
    'valorAgregadoImportacion': function (val) {
      if (val && val !== '') {
        val = parseFloat(val);
        this.tasaServicio !== '' ? this.tasaServicio = parseFloat(this.tasaServicio) : this.tasaServicio = 0
        this.impuestoImportacion !== '' ? this.impuestoImportacion = parseFloat(this.impuestoImportacion) : this.impuestoImportacion = 0
        this.importacionOrdinaria !== '' ? this.importacionOrdinaria = parseFloat(this.importacionOrdinaria) : this.importacionOrdinaria = 0
        this.servicioAduana !== '' ? this.servicioAduana = parseFloat(this.servicioAduana) : this.servicioAduana = 0
        this.estampillas !== '' ? this.estampillas = parseFloat(this.estampillas) : this.estampillas = 0
        let to = val + this.tasaServicio + this.impuestoImportacion + this.importacionOrdinaria + this.servicioAduana + this.estampillas
        this.totalTasaImpuesto = to.toFixed(2)
      } else {
        this.tasaServicio !== '' ? this.tasaServicio = parseFloat(this.tasaServicio) : this.tasaServicio = 0
        this.impuestoImportacion !== '' ? this.impuestoImportacion = parseFloat(this.impuestoImportacion) : this.impuestoImportacion = 0
        this.importacionOrdinaria !== '' ? this.importacionOrdinaria = parseFloat(this.importacionOrdinaria) : this.importacionOrdinaria = 0
        this.servicioAduana !== '' ? this.servicioAduana = parseFloat(this.servicioAduana) : this.servicioAduana = 0
        this.estampillas !== '' ? this.estampillas = parseFloat(this.estampillas) : this.estampillas = 0
        let to = this.tasaServicio + this.impuestoImportacion + this.importacionOrdinaria + this.servicioAduana + this.estampillas
        this.totalTasaImpuesto = to.toFixed(2)
      }
    },
    'servicioAduana': function (val) {
      if (val && val !== '') {
        val = parseFloat(val);
        this.tasaServicio !== '' ? this.tasaServicio = parseFloat(this.tasaServicio) : this.tasaServicio = 0
        this.impuestoImportacion !== '' ? this.impuestoImportacion = parseFloat(this.impuestoImportacion) : this.impuestoImportacion = 0
        this.importacionOrdinaria !== '' ? this.importacionOrdinaria = parseFloat(this.importacionOrdinaria) : this.importacionOrdinaria = 0
        this.valorAgregadoImportacion !== '' ? this.valorAgregadoImportacion = parseFloat(this.valorAgregadoImportacion) : this.valorAgregadoImportacion = 0
        this.estampillas !== '' ? this.estampillas = parseFloat(this.estampillas) : this.estampillas = 0
        let to = val + this.tasaServicio + this.impuestoImportacion + this.importacionOrdinaria + this.valorAgregadoImportacion + this.estampillas
        this.totalTasaImpuesto = to.toFixed(2)
      } else {
        this.tasaServicio !== '' ? this.tasaServicio = parseFloat(this.tasaServicio) : this.tasaServicio = 0
        this.impuestoImportacion !== '' ? this.impuestoImportacion = parseFloat(this.impuestoImportacion) : this.impuestoImportacion = 0
        this.importacionOrdinaria !== '' ? this.importacionOrdinaria = parseFloat(this.importacionOrdinaria) : this.importacionOrdinaria = 0
        this.valorAgregadoImportacion !== '' ? this.valorAgregadoImportacion = parseFloat(this.valorAgregadoImportacion) : this.valorAgregadoImportacion = 0
        this.estampillas !== '' ? this.estampillas = parseFloat(this.estampillas) : this.estampillas = 0
        let to = this.tasaServicio + this.impuestoImportacion + this.importacionOrdinaria + this.valorAgregadoImportacion + this.estampillas
        this.totalTasaImpuesto = to.toFixed(2)
      }
    },
    'estampillas': function (val) {
      if (val && val !== '') {
        val = parseFloat(val);
        this.tasaServicio !== '' ? this.tasaServicio = parseFloat(this.tasaServicio) : this.tasaServicio = 0
        this.impuestoImportacion !== '' ? this.impuestoImportacion = parseFloat(this.impuestoImportacion) : this.impuestoImportacion = 0
        this.importacionOrdinaria !== '' ? this.importacionOrdinaria = parseFloat(this.importacionOrdinaria) : this.importacionOrdinaria = 0
        this.valorAgregadoImportacion !== '' ? this.valorAgregadoImportacion = parseFloat(this.valorAgregadoImportacion) : this.valorAgregadoImportacion = 0
        this.servicioAduana !== '' ? this.servicioAduana = parseFloat(this.servicioAduana) : this.servicioAduana = 0
        let to = val + this.tasaServicio + this.impuestoImportacion + this.importacionOrdinaria + this.valorAgregadoImportacion + this.servicioAduana
        this.totalTasaImpuesto = to.toFixed(2)
      } else {
        this.tasaServicio !== '' ? this.tasaServicio = parseFloat(this.tasaServicio) : this.tasaServicio = 0
        this.impuestoImportacion !== '' ? this.impuestoImportacion = parseFloat(this.impuestoImportacion) : this.impuestoImportacion = 0
        this.importacionOrdinaria !== '' ? this.importacionOrdinaria = parseFloat(this.importacionOrdinaria) : this.importacionOrdinaria = 0
        this.valorAgregadoImportacion !== '' ? this.valorAgregadoImportacion = parseFloat(this.valorAgregadoImportacion) : this.valorAgregadoImportacion = 0
        this.servicioAduana !== '' ? this.servicioAduana = parseFloat(this.servicioAduana) : this.servicioAduana = 0
        let to = this.tasaServicio + this.impuestoImportacion + this.importacionOrdinaria + this.valorAgregadoImportacion + this.servicioAduana
        this.totalTasaImpuesto = to.toFixed(2)
      }
    },
  },

  created () {
    EventBus.$on('dataImportacion', data => {
      console.log('LLEGO A PASO 2', data)
      this.formP2 = data.form
      this.editedIndex = data.editedIndex
      this.read = data.read
      if (data.form.gastos.gastoCotizacionTotal > 0 || data.form.gastos.gastoMontoTotal > 0) {
        this.gastosLocales = data.form.gastos.gastosLocales
        this.gastosDestino = data.form.gastos.gastosDestino
        this.gastoCotizacionTotal = data.form.gastos.gastoCotizacionTotal
        this.gastoMontoTotal = data.form.gastos.gastoMontoTotal
      }
      if (data.form.gastos.totalPreliquidacion > 0 ) {
        this.preliquidacion = data.form.gastos.preliquidacion 
        this.manejoCarga = data.form.gastos.manejoCarga
        this.seguridadVigilancia = data.form.gastos.seguridadVigilancia
        this.despachoCargaContenedor = data.form.gastos.despachoCargaContenedor
        this.posicionamiento = data.form.gastos.posicionamiento
        this.totalPreliquidacion = data.form.gastos.totalPreliquidacion
      }
      if (data.form.gastos.totalAlcance > 0) {
        this.alcances = data.form.gastos.alcances
        this.totalAlcance = data.form.gastos.totalAlcance 
      }
      if (data.form.gastos.totalTasaImpuesto > 0 ) {
        this.tasaServicio = data.form.gastos.tasaServicio 
        this.impuestoImportacion = data.form.gastos.impuestoImportacion
        this.totalTasaImpuesto = data.form.gastos.totalTasaImpuesto
      }
      if (!this.formP2.archivo) {
        this.formP2.archivo = {
          imageName: "",
          imageFile: "",
          imageUrl: ""
        }
      } else {
        this.img = data.img
      }
    })
  },

  methods: {
    enterGastoLocal () {
      this.gastosLocales.push({
        descripcion: '',
        cotizacion: 0,
        nombreEmpresa: '',
        nroDocumento: '',
        monto: 0,
        estatus: ''
      });
    },
    deleteRowLocal(index, row) {
      var idx = this.gastosLocales.indexOf(row);
      if (idx > -1) {
        this.gastosLocales.splice(idx, 1);
      }
      this.changeCotizacion()
      this.changeMonto()
    },
    enterGastoDestino () {
      this.gastosDestino.push({
        descripcion: '',
        cotizacion: 0,
        nombreEmpresa: '',
        nroDocumento: '',
        monto: 0,
        estatus: ''
      });
    },
    deleteRowDestino(index, row) {
      var idx = this.gastosDestino.indexOf(row);
      if (idx > -1) {
        this.gastosDestino.splice(idx, 1);
      }
      this.changeCotizacion()
      this.changeMonto()
    },
    enterAlcance () {
      this.alcances.push({fecha: '', monto: 0 });
    },
    deleteRowAlcance (index, row) {
      var idx = this.alcances.indexOf(row);
      if (idx > -1) {
        this.alcances.splice(idx, 1);
      }
      this.changeMontoAlcance()
    },

    changeCotizacion () {
      this.gastoCotizacionTotal = 0
      let acumCot = 0
      if (this.gastosLocales.length > 0) {
        for (let i = 0; i < this.gastosLocales.length; i++) {
          if (this.gastosLocales[i].cotizacion > 0) {
            acumCot += parseFloat(this.gastosLocales[i].cotizacion)
          }
        }
      }
      if (this.gastosDestino.length > 0) {
        for (let j = 0; j < this.gastosDestino.length; j++) {
          if (this.gastosDestino[j].cotizacion > 0) {
            acumCot += parseFloat(this.gastosDestino[j].cotizacion)
          }
        }
      }
      this.gastoCotizacionTotal = acumCot
      this.gastoCotizacionTotal = (this.gastoCotizacionTotal).toFixed(2)
    },
    changeMonto () {
      this.gastoMontoTotal = 0
      let acumMon = 0
      if (this.gastosLocales.length > 0) {
        for (let i = 0; i < this.gastosLocales.length; i++) {
          if (this.gastosLocales[i].monto > 0) {
            acumMon += parseFloat(this.gastosLocales[i].monto)
          }
        }
      }
      if (this.gastosDestino.length > 0) {
        for (let j = 0; j < this.gastosDestino.length; j++) {
          if (this.gastosDestino[j].monto > 0) {
            acumMon += parseFloat(this.gastosDestino[j].monto)
          }
        }
      }
        this.gastoMontoTotal = acumMon
        this.gastoMontoTotal = (this.gastoMontoTotal).toFixed(2)
      
    },
    changeMontoAlcance () {
      this.totalAlcance = 0
      let acumMon = 0
      if (this.alcances.length > 0) {
        for (let i = 0; i < this.alcances.length; i++) {
          if (this.alcances[i].monto > 0) {
            acumMon += parseFloat(this.alcances[i].monto)
          }
        }
        this.totalAlcance = acumMon
        this.totalAlcance = (this.totalAlcance).toFixed(2)
      }
    },

    gastoOrigenDestino () {
      this.origenDestino = true
      this.tamanno = '90%'
      this.soporte = false
      this.operativo = false
    },
    soporteGasto () {
      this.soporte = true
      this.tamanno = '60%'
      this.origenDestino = false
      this.operativo = false
    },
    gastoOperativo () {
      this.operativo = true
      this.tamanno = '80%'
      this.origenDestino = false
      this.soporte = false
    },

    pickFile () {
      this.$refs.image.click()
    },
    onFilePicked (e) {
      this.formP2.archivo = {
        imageName: '',
        imageFile: '',
        imageUrl: ''
      }
      const files = e.target.files
      if (files[0] !== undefined) {
        let peso = false
        for (let j = 0; j < files.length; j++) {
          if (files[j].size > 4194304) {
            peso = true
          }
        }
        if (peso === false) {
          this.formP2.archivo.imageName = files[0].name
          if (this.formP2.archivo.imageName.lastIndexOf('.') <= 0) {
            return
          }
          const fr = new FileReader()
          fr.readAsDataURL(files[0])
          fr.addEventListener('load', () => {
            this.img = fr.result
            this.formP2.archivo.imageUrl = fr.result
            this.formP2.archivo.imageFile = files[0]
          })
          this.extension = this.formP2.archivo.imageName.slice((this.formP2.archivo.imageName.lastIndexOf(".") - 1 >>> 0) + 2);
        } else {
          this.$swal.fire(
            'Oops...',
            'Error encontrado, la Imagen/Archivo debe pesar menos de 4MB.',
            'error'
          )
          this.files = []
          this.formP2.archivo = []
        }
      } else {
        this.formP2.archivo.imageName = ''
        this.formP2.archivo.imageFile = ''
        this.formP2.archivo.imageUrl = ''
      }
    },

    closePaso2 () {
      this.origenDestino = false
      this.soporte = false
      this.operativo = false
      if (this.gastoCotizacionTotal > 0 || this.gastoMontoTotal > 0) {
        this.formP2.gastosLocales = this.gastosLocales
        this.formP2.gastosDestino = this.gastosDestino
        this.formP2.gastoCotizacionTotal = this.gastoCotizacionTotal
        this.formP2.gastoMontoTotal = this.gastoMontoTotal
      }
      if (this.totalPreliquidacion > 0) {
        this.formP2.gastos.preliquidacion = this.preliquidacion
        this.formP2.gastos.manejoCarga = this.manejoCarga
        this.formP2.gastos.seguridadVigilancia = this.seguridadVigilancia
        this.formP2.gastos.despachoCargaContenedor = this.despachoCargaContenedor
        this.formP2.gastos.posicionamiento = this.posicionamiento
        this.formP2.gastos.totalPreliquidacion = this.totalPreliquidacion
      }
      if (this.totalAlcance > 0) {
        this.formP2.gastos.alcances = this.alcances
        this.formP2.gastos.totalAlcance = this.totalAlcance
      }
      if (this.totalTasaImpuesto) {
        this.formP2.gastos.tasaServicio = this.tasaServicio
        this.formP2.gastos.impuestoImportacion = this.impuestoImportacion
        this.formP2.gastos.importacionOrdinaria = this.importacionOrdinaria
        this.formP2.gastos.valorAgregadoImportacion = this.valorAgregadoImportacion
        this.formP2.gastos.servicioAduana = this.servicioAduana
        this.formP2.gastos.estampillas = this.estampillas
        this.formP2.gastos.totalTasaImpuesto = this.totalTasaImpuesto
      }
      this.$emit('close')
    },

    closePaso3 () {
      this.dialogImportacionP3 = false
    },

    closeTodoP3 () {
      this.dialogImportacionP3 = false
      this.terminarGuardar()
    },

    closeSave3 () {
      console.log('PASO 5')
      this.dialogImportacionP3 = false
      this.gastosLocales = [                       // Local-Destino
        {
          descripcion: 'FLETE INTERNACIONAL',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'GASTOS ADMINISTRATIVOS ORIGEN',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        }
      ],
      this.gastosDestino = [
        {
          descripcion: 'BOLIPUERTOS (ACCESOS)',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'DEMORA (DÍAS)',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'EMISIÓN DEL BL',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'ELEVADORA DE VACÍO-DEVOLUCIÓN DE EQUIPO',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'DEPOSITO DE GARANTÍA',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'IMPUESTO DE IMPORTACIÓN',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'PAGOS PLANILLLAS SENIAT',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'PRELIQUIDACIÓN-DESPACHO',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'INSPECCIÓN',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'SEGURO',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'ALMACENADORA',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
      ],
      this.gastoCotizacionTotal = 0
      this.gastoMontoTotal = 0
      this.preliquidacion = 0,                     // Gasto Nacionalizacion
      this.manejoCarga = 0,
      this.seguridadVigilancia = 0,
      this.despachoCargaContenedor = 0,
      this.posicionamiento = 0,
      this.totalPreliquidacion = 0,
      this.alcances = [ { fecha: '', monto: 0 } ], // Gasto Alcances
      this.totalAlcance = 0,
      this.tasaServicio = 0,                       // Tasa e Impuestos
      this.impuestoImportacion = 0,
      this.importacionOrdinaria = 0
      this.valorAgregadoImportacion = 0
      this.servicioAduana = 0
      this.estampillas = 0
      this.totalTasaImpuesto = 0
      /* this.img = ''
      this.formP2.archivo.imageName = '';
      this.formP2.archivo.imageFile = '';
      this.formP2.archivo.imageUrl = ''; */
      this.origenDestino = false
      this.soporte = false
      this.operativo = false
      this.tamanno = '90%'
      console.log('PASO 6')
      this.$emit('closeSave2')
    },

    validarGastosLocales () {
      let bool = false
      for (let i = 0; i < this.gastosLocales.length; i++) {
        if (
            this.gastosLocales[i].descripcion !== '' && this.gastosLocales[i].cotizacion > 0 && this.gastosLocales[i].nombreEmpresa !== '' &&
            this.gastosLocales[i].nroDocumento !== '' && this.gastosLocales[i].monto > 0 && this.gastosLocales[i].estatus !== ''
        ) {
          bool = true
        } else {
          bool = false
        }
        if (bool === false) {
          this.$swal({
            icon: 'error',
            title: 'Error en los Gastos Locales!',
            text: 'No deben haber campos vacíos o en cero'
          })
          return true
        }
      }
      return false
    },
    validarGastosDestino () {
      let bool = false
      for (let i = 0; i < this.gastosDestino.length; i++) {
        if (
            this.gastosDestino[i].descripcion !== '' && this.gastosDestino[i].cotizacion > 0 && this.gastosDestino[i].nombreEmpresa !== '' &&
            this.gastosDestino[i].nroDocumento !== '' && this.gastosDestino[i].monto > 0 && this.gastosDestino[i].estatus !== ''
        ) {
          bool = true
        } else {
          bool = false
        }

        if (bool === false) {
          this.$swal({
            icon: 'error',
            title: 'Error en los Gastos de Destino!',
            text: 'No deben haber campos vacíos o en cero'
          })
          return true
        }
      }
      return false
    },

    terminarGuardar () {
      if (this.gastoCotizacionTotal > 0 || this.gastoMontoTotal > 0) {
        this.formP2.gastos.gastosLocales = this.gastosLocales
        this.formP2.gastos.gastosDestino = this.gastosDestino
        this.formP2.gastos.gastoCotizacionTotal = this.gastoCotizacionTotal
        this.formP2.gastos.gastoMontoTotal = this.gastoMontoTotal
      }
      if (this.totalPreliquidacion > 0) {
        this.formP2.gastos.preliquidacion = this.preliquidacion
        this.formP2.gastos.manejoCarga = this.manejoCarga
        this.formP2.gastos.seguridadVigilancia = this.seguridadVigilancia
        this.formP2.gastos.despachoCargaContenedor = this.despachoCargaContenedor
        this.formP2.gastos.posicionamiento = this.posicionamiento
        this.formP2.gastos.totalPreliquidacion = this.totalPreliquidacion
      }
      if (this.totalAlcance > 0) {
        this.formP2.gastos.alcances = this.alcances
        this.formP2.gastos.totalAlcance = this.totalAlcance
      }
      if (this.totalTasaImpuesto) {
        this.formP2.gastos.tasaServicio = this.tasaServicio
        this.formP2.gastos.impuestoImportacion = this.impuestoImportacion
        this.formP2.gastos.importacionOrdinaria = this.importacionOrdinaria
        this.formP2.gastos.valorAgregadoImportacion = this.valorAgregadoImportacion
        this.formP2.gastos.servicioAduana = this.servicioAduana
        this.formP2.gastos.estampillas = this.estampillas
        this.formP2.gastos.totalTasaImpuesto = this.totalTasaImpuesto
      }
      this.gastosLocales = [                         // Gastos Origen-Destino
        {
          descripcion: 'FLETE INTERNACIONAL',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'GASTOS ADMINISTRATIVOS ORIGEN',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        }
      ],
      this.gastosDestino = [
        {
          descripcion: 'BOLIPUERTOS (ACCESOS)',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'DEMORA (DÍAS)',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'EMISIÓN DEL BL',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'ELEVADORA DE VACÍO-DEVOLUCIÓN DE EQUIPO',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'DEPOSITO DE GARANTÍA',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'IMPUESTO DE IMPORTACIÓN',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'PAGOS PLANILLLAS SENIAT',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'PRELIQUIDACIÓN-DESPACHO',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'INSPECCIÓN',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'SEGURO',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
        {
          descripcion: 'ALMACENADORA',
          cotizacion: 0,
          nombreEmpresa: '',
          nroDocumento: '',
          monto: 0,
          estatus: ''
        },
      ],
      this.gastoCotizacionTotal = 0
      this.gastoMontoTotal = 0
      this.preliquidacion = 0                     // Gasto Nacionalizacion
      this.manejoCarga = 0,
      this.seguridadVigilancia = 0
      this.despachoCargaContenedor = 0
      this.posicionamiento = 0,
      this.totalPreliquidacion = 0,
      this.alcances = [ { fecha: '', monto: 0 } ]  // Gasto Alcances
      this.totalAlcance = 0
      this.tasaServicio = 0                       // Tasa e Impuestos
      this.impuestoImportacion = 0
      this.importacionOrdinaria = 0
      this.valorAgregadoImportacion = 0
      this.servicioAduana = 0
      this.estampillas = 0
      this.totalTasaImpuesto = 0
      this.origenDestino = false
      this.soporte = false
      this.operativo = false
      this.tamanno = '90%'
      console.log('FORMP2', this.formP2)
      this.$emit('closeTodoP2')
    },

    paso3 () {
      //if (!this.validarGastosLocales() && !this.validarGastosDestino()) {
        if (this.read !== true) {
          if (this.gastoCotizacionTotal > 0 || this.gastoMontoTotal > 0) {
            this.formP2.gastos.gastosLocales = this.gastosLocales
            this.formP2.gastos.gastosDestino = this.gastosDestino
            this.formP2.gastos.gastoCotizacionTotal = this.gastoCotizacionTotal
            this.formP2.gastos.gastoMontoTotal = this.gastoMontoTotal
          }
          if (this.totalPreliquidacion > 0) {
            this.formP2.gastos.preliquidacion = this.preliquidacion
            this.formP2.gastos.manejoCarga = this.manejoCarga
            this.formP2.gastos.seguridadVigilancia = this.seguridadVigilancia
            this.formP2.gastos.despachoCargaContenedor = this.despachoCargaContenedor
            this.formP2.gastos.posicionamiento = this.posicionamiento
            this.formP2.gastos.totalPreliquidacion = this.totalPreliquidacion
          }
          if (this.totalAlcance > 0) {
            this.formP2.gastos.alcances = this.alcances
            this.formP2.gastos.totalAlcance = this.totalAlcance
          }
          if (this.totalTasaImpuesto) {
            this.formP2.gastos.tasaServicio = this.tasaServicio
            this.formP2.gastos.impuestoImportacion = this.impuestoImportacion
            this.formP2.gastos.importacionOrdinaria = this.importacionOrdinaria
            this.formP2.gastos.valorAgregadoImportacion = this.valorAgregadoImportacion
            this.formP2.gastos.servicioAduana = this.servicioAduana
            this.formP2.gastos.estampillas = this.estampillas
            this.formP2.gastos.totalTasaImpuesto = this.totalTasaImpuesto
          }
        }
        let array = { // Bus a ImportacionP3.vue
          formP2: this.formP2,
          editedIndex: this.editedIndex,
          read: this.read
        }
        EventBus.$emit('dataImportacion2', array)
        this.dialogImportacionP3 = true
      //} 
    }
  }
}
</script>

<style lang="scss">
  .inputGastos {
    padding: 0px 1px 0px 0px;
  }
  .inputGastos2 {
    padding: 5px 5px 25px 5px;
  }
  .inputCotiMont {
    padding: 0px 1px 0px 0px;
    width: 9%;
  }
  .inputEstatus {
    padding: 0px 1px 0px 0px;
    width: 12%;
  }
  .inputDocumento {
    padding: 0px 1px 0px 0px;
    width: 11%;
  }
  .bold {
    font-weight: bold;
  }
  .img-pro {
    padding: 0px 0px 0px 0px;
    text-align: center
  }
  .espacio1 {
    margin-right: 3%;
  }
  .espacio2 {
    margin-right: 3%;
    margin-left: 3%;
  }
  .espacio3 {
    margin-left: 3%;
  }
  .top-black {
    border-top: 1px solid gray;
  }
  .inputOperativo {
    padding: 0px 4px 0px 0px;
  }
  .inputOperativo2 {
    padding: 0px 4px 0px 0px;
    width: 25%;
  }
  .inputTasa {
    padding: 0px 4px 0px 0px;
  }
  .inputTasa2 {
    padding: 0px 4px 0px 0px;
    width: 35%;
  }
</style>
